const prodConfig = {
    baseURL : 'https://api-cross-word-admin.gamedistribution.com',
    env:'prod',
    dictionary: '60103f273cd16700118157e3'
};
const prodKaanConfig = {
    baseURL : 'https://api-cross-word-admin.gamedistribution.com',
    env:'prod',
    dictionary: '603c979328d05b0011aee81e'
};
//603c979328d05b0011aee81e
const devConfig = {
    baseURL : 'http://localhost:9091',
    //baseURL : 'https://api-cross-word-admin.gamedistribution.com',
    env:'dev',
    dictionary: '600e7ed210a6d967c4e5ddea'
}

//60269d0755435461c026ba3e

const devMACConfig = {
    baseURL : 'http://localhost:9091',
    //baseURL : 'https://api-cross-word-admin.gamedistribution.com',
    env:'dev',
    dictionary: '60269d0755435461c026ba3e'
}

const devMACKaanConfig = {
    baseURL : 'http://localhost:9091',
    //baseURL : 'https://api-cross-word-admin.gamedistribution.com',
    env:'dev',
    dictionary: '603657a7e1d2c22525695f98'
}

const devWinKaanConfig = {
    baseURL : 'http://192.168.31.78:9091',
    //baseURL : 'https://api-cross-word-admin.gamedistribution.com',
    env:'dev',
    dictionary: '6041d55eaf9aef346470a6fd'
}

let configLoaded = devConfig;

if(process.env.REACT_APP_STAGE === 'production'){
    configLoaded = prodConfig;
}else if(process.env.REACT_APP_STAGE === 'production-kaan'){
    configLoaded = prodKaanConfig;
}else if(process.env.REACT_APP_STAGE === 'dev-mac'){
    configLoaded = devMACConfig;
}else if(process.env.REACT_APP_STAGE === 'dev-mac-kaan'){
    configLoaded = devMACKaanConfig;
}else if(process.env.REACT_APP_STAGE === 'dev-win-kaan'){
    configLoaded = devWinKaanConfig;
}
export const config = {...configLoaded};
